import awsPath, {
  awsAccessKeyId,
  awsBucketName,
  awsRegion,
  awsSecretAccessKey,
} from "./awsPaths";

// import AWS from 'aws-sdk'
import Api from "../helpers/apiHandler";
import { Map } from "immutable";
import SS3 from "aws-sdk/clients/s3";
import authActions from "../redux/auth/actions";
import menuList, { superadminDashboard } from "../containers/Sidebar/options";
import { store } from "../redux/store";
import options from "../containers/Sidebar/options";
import { loginUserType, moduleIds, newPermissionValue } from "./constants";
import moment from "moment";

const s3 = new SS3({
  accessKeyId: awsAccessKeyId,
  secretAccessKey: awsSecretAccessKey,
});

const api = new Api();

export const imageExtensions = ["jpeg", "jpg", "png"];
const mimeByExtension = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  svg: "image/svg+xml",
  pdf: "application/pdf",
  txt: "text/plain",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

const getS3ContentType = (fileToUpload, flag) => {
  const providedType = (fileToUpload && fileToUpload.type ? fileToUpload.type : "").trim();
  const fileName = fileToUpload && fileToUpload.name ? fileToUpload.name : "";
  const extension = fileName.includes(".")
    ? fileName.split(".").pop().toLowerCase()
    : "";
  const inferredType = mimeByExtension[extension] || "";

  // Some browsers/canvas uploads send "application/octet-stream" for valid images.
  if (!providedType || providedType === "application/octet-stream") {
    if (flag === "electronicSignature") {
      return inferredType || "image/jpeg";
    }
    return inferredType || "application/octet-stream";
  }

  return providedType;
};

export function clearToken() {
  localStorage.removeItem("id_token");
  const storeObject = {
    accountStatus: "",
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    profileImage: "",
    role: "",
    type: "",
    isLoggedIn: false,
    accessToken: getXAPIKey(),
  };
  store.dispatch(authActions.updateProfile(storeObject));
}

/**
 * Builds minimal Redux `company` from login / refresh payload when `company` is omitted.
 */
export const companyFromAuthUserPayload = (data) => {
  if (!data || typeof data !== "object") return null;
  if (data.company != null && typeof data.company === "object") {
    const cid = Number(data.company.id);
    if (Number.isFinite(cid) && cid > 0) {
      return {
        id: cid,
        name: data.company.name != null ? String(data.company.name) : "",
        productionUnitCount:
          data.company.productionUnitCount != null
            ? Number(data.company.productionUnitCount)
            : 0,
      };
    }
  }
  const rawId =
    data.companyId != null
      ? data.companyId
      : data.employerId != null
        ? data.employerId
        : null;
  const cid = Number(rawId);
  if (!Number.isFinite(cid) || cid <= 0) return null;
  return {
    id: cid,
    name: data.companyName != null ? String(data.companyName) : "",
    productionUnitCount: 0,
  };
};

export function getToken() {
  try {
    const idToken = localStorage.getItem("id_token");
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function getProfileDetail() {
  const isLogin = localStorage.getItem("isLoggedIn");
  if (isLogin === "true" || isLogin === true) {
    api
      .post("user/onRefreshGetView")
      .then((e) => {
        if (e.status == "1") {
          new Promise(() => {
            // store.dispatch(authActions.checkAuthorization());

            let allUserPermissionList = [];
            let existsPermissionList = [];
            if (e.data.activatePlanModuleList.length > 0) {
              if (
                e.data.type === loginUserType.admin &&
                e.data.allModuleList.length > 0
              ) {
                //  this is commented Because Currently we Dont have the plan concept
                // existsPermissionList = e.data.allModuleList.filter((x) =>
                //   e.data.activatePlanModuleList.includes(x.name)
                // ); 
                existsPermissionList = e.data.allModuleList;
                allUserPermissionList = existsPermissionList.map(
                  (permissionObj) => {
                    const { id, name, status, description } = permissionObj;

                    const userPermission = {
                      moduleId: id,
                      moduleName: name,
                      permissionId: 1,
                      moduleStatus: status,
                      moduleDescription: description,
                      subModules: [],
                    };
                    return userPermission;
                  }
                );
              } else if (e.data.type === loginUserType.employee) {
                existsPermissionList =
                  e.data.empPermissionList.length > 0
                    ? e.data.empPermissionList
                    : e.data.rolePermissionList;
                //  this is commented Because Currently we Dont have the plan concept
                // existsPermissionList = existsPermissionList.filter((x) =>
                //   e.data.activatePlanModuleList.includes(x.moduleName)
                // );
                allUserPermissionList = existsPermissionList.map(
                  (permissionObj) => {
                    const {
                      moduleId,
                      moduleName,
                      permissionId,
                      status,
                      description,
                      subModules,
                      isCheck,
                    } = permissionObj;

                    // Set isCheck based on permissionId if not already set
                    // permissionId 5 (noAccess) means isCheck should be false
                    // Other permissionIds (1, 2, 3) mean isCheck should be true
                    const finalIsCheck = isCheck !== undefined 
                      ? isCheck 
                      : (permissionId !== newPermissionValue.noAccess);

                    const userPermission = {
                      moduleId,
                      moduleName,
                      permissionId,
                      moduleStatus: status,
                      moduleDescription: description,
                      isCheck: finalIsCheck,
                      subModules: subModules.map((subModule) => ({
                        subModuleId: subModule.subModuleId,
                        tabName: subModule.subModuleName,
                        subModuleFieldVisibility:
                          subModule.subModuleFieldVisibility,
                        isTabVisible: subModule.isTabVisible,
                        description: subModule.description,
                        // Set isCheck for submodules based on permissionId
                        isCheck: subModule.isCheck !== undefined 
                          ? subModule.isCheck 
                          : (subModule.permissionId !== undefined && subModule.permissionId !== newPermissionValue.noAccess),
                        permissionId: subModule.permissionId || permissionId,
                      })),
                    };

                    return userPermission;
                  }
                );
              }
            }

            // sort Array by module Id
            // allUserPermissionList.sort((a, b) => {
            //   return a.moduleId - b.moduleId;
            // });

            const companyFromPayload = companyFromAuthUserPayload(e.data);
            const storeObject = {
              accountStatus: e.data.accountStatus,
              email: e.data.email,
              firstName: e.data.firstName,
              id: e.data.id,
              lastName: e.data.lastName,
              profileImage: e.data.profileImage,
              role: e.data.role,
              type: e.data.type,
              activatedPlanId: e.data.activatedPlanId,
              anyPlanActivated: e.data.anyPlanActivated,
              activatePlanModuleList: e.data.activatePlanModuleList,
              allModuleList: e.data.allModuleList || [],
              menuSystemModuleList: e.data.menuSystemModuleList || [],
              empPermissionList: e.data.empPermissionList,
              rolePermissionList: e.data.rolePermissionList,
              menuSystemAccessibleModuleList:
                e.data.menuSystemAccessibleModuleList,
              sideBarItems:
                e.data.type === "superadmin"
                  ? superadminDashboard
                  : allUserPermissionList,
              ...(companyFromPayload ? { company: companyFromPayload } : {}),
            };
            store.dispatch(authActions.updateProfile(storeObject));

            const url = "company/list/" + e.data.id;
            api
              .get(url)
              .then((response) => {
                if (response.status === 1) {
                  const companies =
                    response.data.list ||
                    response.data.companyList ||
                    [];
                  const first =
                    Array.isArray(companies) && companies.length > 0
                      ? companies[0]
                      : null;
                  if (first) {
                    store.dispatch(
                      authActions.updateProfile({
                        company: first,
                      })
                    );
                  }
                }
              })
              .catch((error) => {
                return error;
              });
          });
        }
      })
      .catch((e) => console.log(e));
  }

  const handleLogout = () => {
    let url = "user/logout";
    api
      .post(url)
      .then((response) => {
        if (response.status === 1) {
          this.props.logout();
        }
      })
      .catch((error) => {
        return error;
      });
  };
}

export function getDeviceType() {
  return "web";
}

export function getXAPIKey() {
  return "eyJhbGciOiJIUzUxMiJ9";
}

export function setPermissionType(permissions) {
  let restrictedMenu = menuList.map((ele, i) => {
    if (permissions) {
      ele.permissionLevel = permissions[i];
      return ele;
    } else {
      ele.permissionLevel = 1;
      return ele;
    }
  });
  return restrictedMenu;
}

export function readFileContent(file) {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}

//comment function to use async await
// export  function exportToS3 (fileToUpload, flag) {
//   var params = {
//     Body: fileToUpload,
//     Bucket: awsBucketName,
//     Key: `${awsPath[flag]}/${fileToUpload.name}`,
//     // Metadata: {
//     //   'Content-Disposition': 'attachment'
//     // },
//     ACL: "public-read",
//     ContentType: fileToUpload.type,
//   }

//   s3.putObject(params, (err, data) => {
//     if (err) {
//       console.log(err);
//     }
//   })
// }

export function exportToS3(fileToUpload, flag) {
  return new Promise((resolve, reject) => {
    const params = {
      Body: fileToUpload,
      Bucket: awsBucketName,
      Key: `${awsPath[flag]}/${fileToUpload.name}`,
      ACL: "public-read",
      ContentType: getS3ContentType(fileToUpload, flag),
    };

    s3.putObject(params, (err, data) => {
      if (err) {
        console.error(err);
        reject(err);
      } else {
        resolve(data);
      }
    });
  });
}

export function deleteFromS3(fileToUpload, flag) {
  return new Promise((resolve, reject) => {
    s3.deleteObject(
      {
        Bucket: awsBucketName,
        Key: `${awsPath[flag]}/${fileToUpload}`,
      },
      (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      }
    );
  });
}

/** Map DB/sidebar moduleName to the AppRouter path segment (no leading slash). */
export function resolveModuleRoutePath(moduleName) {
  const name = String(moduleName || "")
    .toLowerCase()
    .trim();
  if (
    name === "copacker" ||
    name === "co-packer" ||
    name === "co-packers"
  ) {
    return "co-packer";
  }
  if (name === "assemblies" || name === "assembly") {
    return "assemblies";
  }  
  if (
    name === "finished goods" ||
    name === "finished-goods" ||
    name === "finishedgoods" ||
    name === "finished good" ||
    name === "finishedgood"
  ) {
    return "finished-goods";
  }
  return String(moduleName || "");
}

export function getLogo(str) {
  const name = String(str || "")
    .toLowerCase()
    .trim();
  switch (name) {
    case "dashboard":
      return "fas fa-columns";
    case "company":
      return "far fa-building";
    case "employees":
      return "fas fa-user-tie";
    case "manufacturer":
      return "fas fa-industry";
    case "copacker":
    case "co-packer":
      return "fas fa-boxes";
    case "finished-goods":
    case "finishedgoods":
    case "finished goods":
      return "fas fa-box-open";
    case "customers":
      return "fas fa-user-shield";
    case "supplier":
      return "fas fa-truck-moving";
    case "ingredients":
      return "fas fa-fill-drip";
    case "purchase-orders":
      return "fas fa-money-check";
    case "units":
      return "fas fa-balance-scale";
    case "customer_orders":
      return "fas fa-shipping-fast";
    case "inventory":
      return "fas fa-warehouse";
    case "labs":
      return "fas fa-flask";
    case "task_list":
      return "fas fa-door-open";
    case "recipe":
      return "fas fa-utensils";
    case "assemblies":
    case "assembly":
      return "fas fa-cubes";
    case "visitors":
      return "fas fa-street-view";
    case "inspections":
      return "fas fa-tasks";
    case "checklists":
      return "fas fa-clipboard-check";
    case "settings":
      return "fas fa-tools";
    case "reports":
      return "far fa-clipboard";
    case "companies":
      return "far fa-chart-bar";
    case "membership":
      return "fas fa-users-cog";
    case "task":
      return "fas fa-tasks";
    case "certification":
      return "fa fa-certificate";
    case "document-control":
      return "fas fa-list";
    default:
      return "far fa-building";
  }
}

export function getMenuItemData(str, sideBarItems) {
  let name = str && str.toLowerCase();
  let menuItemData = null;
  if (name === "companies") {
    menuItemData = {
      icon: "fas fa-building",
      title: "Companies",
      route: "/companies",
      modules: ["companies"],
    };
  } else if (name === "membership settings") {
    menuItemData = {
      icon: "fas fa-users-cog",
      title: "Membership Settings",
      route: "/membership",
      modules: ["membership"],
    };
  } else if (name === "weights and measures") {
    menuItemData = {
      icon: "fas fa-balance-scale",
      title: "Weights & Measures",
      route: "/units",
      modules: ["weights", "measures"],
    };
  } else if (name === "roles") {
    menuItemData = {
      icon: "fas fa-id-badge",
      title: "Roles",
      route: "/roles",
      modules: ["roles"],
    };
  } else if (name === "feedback") {
    menuItemData = {
      icon: "fas fa-id-badge",
      title: "Feedback",
      route: "/feedback",
      modules: ["feedback"],
    };
  } 
  // else if (name === "currency") {
  //   menuItemData = {
  //     icon: "fas fa-tools",
  //     title: "Settings",
  //     route: "/currency",
  //     modules: ["currency"],
  //   };
  // }
  else if (name === "global safety certificates") {
    menuItemData = {
      icon: "fas fa-shield-alt",
      title: "Safety Data Sheets",
      route: "/globalsafetycertificates",
      modules: ["global safety certificates"],
    };
  } else if (name === "global ingredient") {
    menuItemData = {
      icon: "fas fa-flask",
      title: "Global Ingredient",
      route: "/globalingredient",
      modules: ["global-ingredient", "global ingredient"],
    };
  } else if (
    name === "allergen identification & term management" ||
    name === "allergens"
  ) {
    menuItemData = {
      icon: "fas fa-allergies",
      title: "Allergen Identification",
      route: "/allergens",
      modules: ["allergens", "allergen identification & term management"],
    };
  } else if (name === "usda ingredients" || name === "usda-ingredients") {
    menuItemData = {
      icon: "fas fa-seedling",
      title: "USDA Ingredients",
      route: "/usda-ingredients",
      modules: ["usda-ingredients", "usda ingredients"],
    };
  } else if (name === "ffl usage analytics" || name === "ffl-analytics") {
    menuItemData = {
      icon: "fas fa-chart-bar",
      title: "FFL Usage Analytics",
      route: "/ffl-analytics",
      modules: ["ffl-analytics", "ffl usage analytics"],
    };
  } else if (name === "signup access" || name === "signup-access") {
    menuItemData = {
      icon: "fas fa-key",
      title: "Signup Access",
      route: "/signup-access",
      modules: ["signup-access", "signup access"],
    };
  } else if (
    name === "finished goods" ||
    name === "finished-goods" ||
    name === "finishedgoods"
  ) {
    menuItemData = {
      icon: "fas fa-box-open",
      title: "Finished Goods",
      route: "/finished-goods",
      modules: ["finished goods", "finished-goods", "finishedgoods"],
    };
  }else if (name === "home") {
    menuItemData = {
      icon: "fas fa-home",
      title: "Home",
      route: "/dashboard",
      modules: ["dashboard"],
    };
  } else if (name === "task and messaging") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "task" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/task";
      }
    }
    menuItemData = {
      icon: "fas fa-tasks",
      title: "Tasks and Messaging",
      route,
      modules: ["task", "messages"],
    };
  } else if (name === "regulatory and compliance") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      const regulatoryAllowed = (slug) =>
        sideBarItems.find((item) => {
          const desc = item.moduleDescription || item.description;
          return (
            permissionModuleNameMatchesRoutePath(
              item.moduleName,
              desc,
              slug
            ) && item.permissionId != newPermissionValue.noAccess
          );
        });
      if (regulatoryAllowed("inspections")) {
        route = "/inspections";
      } else if (regulatoryAllowed("checklists")) {
        route = "/checklists";
      } else if (regulatoryAllowed("safety")) {
        route = "/safety";
      } else if (regulatoryAllowed("certification")) {
        route = "/certification";
      } else if (regulatoryAllowed("document-control")) {
        route = "/document-control";
      } else {
        route = "/visitors";
      }
    }
  
    menuItemData = {
      icon: "fa fa-gavel",
      title: "Regulatory & Compliance",
      route,
      modules: [
        "inspections",
        "checklists",
        "visitors",
        "safety",
        "certification",
        "document-control",
      ],
    };
  }
   else if (name === "production") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "Production Run" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/production";
      } else if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "recipe" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/recipe";
      } else if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "assemblies" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/assemblies";
      } else {
        route = "/ingredients";
      }
    }
    menuItemData = {
      icon: "fa fa-industry",
      title: "Production",
      route,
      modules: ["production", "recipe", "assemblies"],
    };
  } else if (name === "inventory") {
    menuItemData = {
      icon: "fas fa-warehouse",
      title: "Inventory",
      route: "/inventory",
      modules: ["inventory", "ingredients", "materials", "lot-documentation", "finished-goods"],
    };
  } else if (name === "assets") {
    menuItemData = {
      icon: "fas fa-boxes",
      title: "Assets",
      route: "/assets",
      modules: ["assets"],
    };
  } else if (name === "customers") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "customers" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/customers";
      } else {
        route = "/customer_orders";
      }
    }
    menuItemData = {
      icon: "fa fa-users",
      title: "Customers",
      route,
      modules: ["customers", "customer_orders"],
    };
  } else if (name === "supplier") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "supplier" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/supplier";
      } else if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "manufacturer" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/manufacturer";
      } else if (
        sideBarItems.find(
          (item) =>
            (item.moduleName === "copacker" ||
              item.moduleName === "co-packer") &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/co-packer";
      } else {
        route = "/purchase-orders";
      }
    }
    menuItemData = {
      icon: "fas fa-shipping-fast",
      title: "Suppliers",
      route,
      modules: [
        "supplier",
        "manufacturer",
        "co-packer",
        "copacker",
        "purchase-orders",
      ],
    };
  } else if (name === "reports") {
    menuItemData = {
      icon: "far fa-clipboard",
      title: "Reports",
      route: "/reports",
      modules: ["reports"],
    };
  } else if (name === "hr") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "employees" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/employees";
      } else if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "teams" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/teams";
      } else if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "users" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/users";
      } else {
        route = "/roles";
      }
    }
    menuItemData = {
      icon: "fas fa-id-badge",
      title: "HR",
      route,
      modules: ["employees", "teams", "roles", "users"],
    };
  } else if (name === "settings") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "My Settings" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/my-settings";
      } else {
        route = "/global-settings";
      }
    }
    menuItemData = {
      icon: "fas fa-tools",
      title: "Settings",
      route,
      modules: ["my-settings", "global-settings", "settings"],
    };
  }
  // } else if (name === "certification") {
  //   let route = "";
  //   if (sideBarItems && sideBarItems.length > 0) {
  //     if (
  //       sideBarItems.find(
  //         (item) =>
  //           item.moduleName === "Certification" &&
  //           item.permissionId != newPermissionValue.noAccess
  //       )
  //     ) {
  //       route = "/certification";
  //     } else {
  //       route = "/certification";
  //     }
  //   }
  //   menuItemData = {
  //     icon: "fas fa-tools",
  //     title: "Certification",
  //     description: "certification",
  //     route,
  //     modules: ["certification"],
  //   };
  // } 
    else if (name === "company") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "company" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/company";
      } else {
        route = "/company";
      }
    }
    menuItemData = {
      icon: "fas fa-tools",
      title: "Company",
      description: "company",
      route,
      modules: ["company"],
    };
  } else if (name === "safety") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "safety" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/safety";
      } else {
        route = "/safety";
      }
    }
    menuItemData = {
      icon: "fas fa-tools",
      title: "Safety",
      description: "safety",
      route,
      modules: ["safety"],
    };
  }
  else if (name === "certification") {
    let route = "";
    if (sideBarItems && sideBarItems.length > 0) {
      if (
        sideBarItems.find(
          (item) =>
            item.moduleName === "certification" &&
            item.permissionId != newPermissionValue.noAccess
        )
      ) {
        route = "/certification";
      } else {
        route = "/certification";
      }
    }
    menuItemData = {
      icon: "fas fa-gears",
      title: "Global Certification",
      description: "Global Certification",
      route,
      modules: ["certification"],
    };
  }
  
  return menuItemData;
}

/**
 * Filters employee permissions based on a reference list.
 * If a module has isCheck: false in BOTH, it's hidden.
 * Used for Employee Login only in My Settings page.
 * 
 * @param {Array} currentList - Permissions from get-emp-permission-with-disable API
 * @param {Array} referenceList - Permissions from Redux (rolePermissionList on login, empPermissionList on refresh)
 * @returns {Array} Filtered permissions
 */
export const filterEmployeePermissions = (currentList, referenceList) => {
  if (!currentList || !Array.isArray(currentList)) return [];
  if (!referenceList || !Array.isArray(referenceList)) return currentList;

  return currentList.filter((perm) => {
    // Find matching module by moduleId
    const refPerm = referenceList.find((rp) => rp.moduleId === perm.moduleId);
    
    if (refPerm) {
      // Hide if isCheck is false in BOTH
      if (perm.isCheck === false && refPerm.isCheck === false) {
        return false;
      }
    }
    return true;
  });
};

/**
 * Whether a permission row in sideBarItems grants access to a module/tab.
 * Matches by moduleId, moduleName, description, or moduleDescription.
 */
export const hasSidebarModuleAccess = (
  sideBarItems,
  { moduleId, moduleName, description } = {}
) => {
  if (!sideBarItems || !Array.isArray(sideBarItems) || sideBarItems.length === 0) {
    return true;
  }

  const entry = sideBarItems.find((item) => {
    if (moduleId != null && item.moduleId === moduleId) {
      return true;
    }
    if (moduleName && item.moduleName === moduleName) {
      return true;
    }
    if (
      description &&
      (item.description === description || item.moduleDescription === description)
    ) {
      return true;
    }
    return false;
  });

  if (!entry) {
    return true;
  }
  // Tab/sub-module access follows permissionId (role radio), not isCheck alone.
  // API can return permissionId 1 with isCheck false for nested tab modules.
  if (entry.permissionId != null) {
    return entry.permissionId !== newPermissionValue.noAccess;
  }
  if (entry.isCheck === false) {
    return false;
  }
  return true;
};

/**
 * Maps API module labels (e.g. "Document Control") to app route segments (e.g. "document-control").
 * Used by AppRouter when filtering employee routes.
 */
export const permissionModuleNameMatchesRoutePath = (
  moduleName,
  description,
  routePath
) => {
  const route = String(routePath || "").toLowerCase().trim();
  if (!route) return false;
  const compact = (value) =>
    String(value || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]/g, "");
  const routeCompact = compact(route);
  const candidates = [moduleName, description]
    .filter((v) => v != null && String(v).trim() !== "")
    .map((s) => String(s).trim());
  for (const raw of candidates) {
    if (raw === routePath || raw.toLowerCase() === route) {
      return true;
    }
    const normalized = raw
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
    if (normalized === route) {
      return true;
    }
    // Match DB module names like "copacker" to routes like "co-packer"
    if (compact(raw) === routeCompact || compact(normalized) === routeCompact) {
      return true;
    }
  }
  return false;
};

/** Strip trailing slashes from a module base match URL (e.g. `/employees/` → `/employees`). */
export const normalizeModuleBasePath = (matchUrl) =>
  String(matchUrl || "").replace(/\/+$/, "") || "/";

/** First path segment from a react-router match URL (e.g. `/employees/` → `employees`). */
export const getModuleNameFromMatchUrl = (matchUrl) => {
  const normalized = String(matchUrl || "").replace(/^\/+|\/+$/g, "");
  return normalized.split("/")[0] || "";
};

/** Build nested module route paths without forcing a trailing slash on the list route. */
export const buildModuleNestedRoutePath = (baseUrl, subPath) => {
  const base = normalizeModuleBasePath(baseUrl);
  if (!subPath) {
    return base;
  }
  return `${base}/${subPath}`;
};

/** Whether a sidebar permission row should unlock the given route `path` for employees. */
export const employeePermissionMatchesAppRoute = (module, routePath) => {
  if (!module || !routePath) return false;
  return [
    module.moduleName,
    module.moduleDescription,
    module.description,
  ].some(
    (part) =>
      part != null &&
      String(part).trim() !== "" &&
      permissionModuleNameMatchesRoutePath(part, "", routePath)
  );
};

export function differentiateUnits(mixedArray) {
  let standardArr = [];
  let customArr = [];
  mixedArray.map((ele) => {
    if (ele.companyId) customArr.push(ele);
    else standardArr.push(ele);
  });
  return { standardArr, customArr };
}

export async function createThumb(file) {
  return new Promise((resolve, reject) => {
    const obj = {};
    readFileContent(file)
      .then((content) => {
        const img = document.createElement("img");
        img.src = content;
        img.onload = () => {
          const MAX_WIDTH = 75;
          const MAX_HEIGHT = 75;
          let { naturalWidth: width, naturalHeight: height } = img;

          if (width > MAX_WIDTH || height > MAX_HEIGHT) {
            if (width / height > MAX_WIDTH / MAX_HEIGHT) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            } else {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              const base64data = reader.result;
              const today = new Date();
              const imageName = `${today.getTime() + Math.floor(Math.random() * (20 - 0 + 1)) + 0
                }.png`;
              const compressed = {
                blob: blob,
                base64: base64data,
                name: today.getTime(),
                file: new File([blob], imageName),
              };
              obj.thumbImage = compressed;
              obj.renameImageName = imageName;
              const originalImg = {
                blob: blob,
                base64: base64data,
                name: today.getTime(),
                file: new File([blob], imageName),
              };
              obj.originalImage = originalImg;
              resolve(obj); // Resolve the promise with the populated object
            };
          });
        };
      })
      .catch((error) => {
        console.log(error);
        reject(error); // Reject the promise if there's an error
      });
  });
}

// Function to generate random string
export const generateRandomString = (length = 8) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

// export const phoneNumberValidator = (rule, value, callback) => {
//   try {
//     const regex = /^[0-9+\-()]{1,}$/;
//     if (value && !regex.test(value)) {
//       throw new Error(
//         "Phone number must contain only numbers and the following characters: +, -, (, )"
//       );
//     } else {
//       // Count only digits for length validation
//       const digitsOnly = value.replace(/[^0-9]/g, '');
//       if (digitsOnly.length > 15) {
//         throw new Error("Phone number must contain maximum 15 digits!");
//       }
//       callback();
//     }
//   } catch (err) {
//     callback(err);
//   }
// };
export const phoneNumberValidator = (rule, value, callback) => {
  try {
    // If field is empty, let the required rule handle it
    if (!value || value.trim() === '') {
      callback();
      return;
    }

    const regex = /^[0-9().-]*$/;
    if (!regex.test(value)) {
      throw new Error(
        "Phone number must contain only numbers and the following characters: . - ( )"
      );
    }

    // Count all characters (digits and allowed symbols)
    if (value.length > 15) {
      throw new Error("Phone number must contain maximum 15 characters!");
    }

    // Extract only digits for validation
    const digitsOnly = value.replace(/[^0-9]/g, '');
    
    // Check for minimum length (at least 7 digits for a valid phone number)
    if (digitsOnly.length < 7) {
      throw new Error("Phone number must contain at least 7 digits!");
    }

    // Check for invalid patterns
    if (digitsOnly.length > 0) {
      // Check for all zeros (000000000, 000-000-0000, etc.)
      if (/^0+$/.test(digitsOnly)) {
        throw new Error("Phone number cannot be all zeros!");
      }

      // Check for repeated single digit (111111111, 222-222-2222, etc.)
      if (/^(\d)\1+$/.test(digitsOnly)) {
        throw new Error("Phone number cannot be all the same digit!");
      }

    }

    callback();
  } catch (err) {
    callback(err);
  }
};

// Enhanced validation functions for supplier form
export const nameValidator = (rule, value, callback) => {
  try {
    // If field is empty, let the required rule handle it
    if (!value || value.trim() === '') {
      callback();
      return;
    }
    
    // Check if name starts with whitespace only
    if (value !== value.trimStart()) {
      throw new Error('Name cannot start with whitespace');
    }
    
    const trimmedValue = value.trim();
    
    // Check minimum length
    if (trimmedValue.length < 2) {
      throw new Error('Name must be at least 2 characters long');
    }
    
    // Check maximum length
    if (trimmedValue.length > 100) {
      throw new Error('Name must not exceed 100 characters');
    }
    
    // Check for valid characters (letters, spaces, hyphens, apostrophes, periods)
    const nameRegex = /^[a-zA-Z\s\-'\.]+$/;
    if (!nameRegex.test(trimmedValue)) {
      throw new Error('Name can only contain letters, spaces, hyphens, apostrophes, and periods');
    }
    
    // Check for consecutive special characters
    if (/(\s{2,}|-{2,}|'{2,}|\.{2,})/.test(trimmedValue)) {
      throw new Error('Name cannot contain consecutive special characters');
    }
    
    // Check that name doesn't start or end with special characters (excluding spaces since we handle them above)
    if (/^[\-'\.]|[\-'\.]$/.test(trimmedValue)) {
      throw new Error('Name cannot start or end with hyphens, apostrophes, or periods');
    }
    
    callback();
  } catch (err) {
    callback(err);
  }
};

export const emailValidator = (rule, value, callback) => {
  try {
    // If field is empty, let the required rule handle it
    if (!value || value.trim() === '') {
      callback();
      return;
    }
    
    // Check if email starts with whitespace only
    if (value !== value.trimStart()) {
      throw new Error('Email cannot start with whitespace');
    }
    
    const trimmedValue = value.trim();
    
    // Check maximum length
    if (trimmedValue.length > 254) {
      throw new Error('Email must not exceed 254 characters');
    }
    
    // Enhanced email regex pattern
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    
    if (!emailRegex.test(trimmedValue)) {
      throw new Error('Please enter a valid email address');
    }
    
    // Check for consecutive dots
    if (trimmedValue.includes('..')) {
      throw new Error('Email cannot contain consecutive dots');
    }
    
    // Check local part length (before @)
    const localPart = trimmedValue.split('@')[0];
    if (localPart.length > 64) {
      throw new Error('Email local part must not exceed 64 characters');
    }
    
    // Check domain part length (after @)
    const domainPart = trimmedValue.split('@')[1];
    if (domainPart && domainPart.length > 253) {
      throw new Error('Email domain part must not exceed 253 characters');
    }
    
    callback();
  } catch (err) {
    callback(err);
  }
};

/**
 * Strict external link URL check: requires http://, https://, or www. prefix.
 * @returns {string|null} Error message, or null when valid.
 */
export const validateExternalWebsiteUrl = (value) => {
  if (!value || String(value).trim() === "") {
    return null;
  }
  if (value !== String(value).trimStart()) {
    return "URL cannot start with whitespace";
  }
  const trimmed = String(value).trim();
  if (trimmed.length > 2048) {
    return "URL must not exceed 2048 characters";
  }
  if (/\s/.test(trimmed)) {
    return "Please enter a valid URL";
  }
  if (trimmed.includes("@")) {
    return "Please enter a valid URL";
  }
  if (/^https?:\/[^/]/i.test(trimmed) || /^https?\/\//i.test(trimmed)) {
    return "Please enter a valid URL";
  }
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed) && !/^https?:\/\//i.test(trimmed)) {
    return "Only http:// and https:// URLs are allowed";
  }
  if (!/^https?:\/\//i.test(trimmed) && !/^www\./i.test(trimmed)) {
    return "URL must start with http://, https://, or www.";
  }

  const normalized = /^www\./i.test(trimmed) ? `https://${trimmed}` : trimmed;
  let parsed;
  try {
    parsed = new URL(normalized);
  } catch {
    return "Please enter a valid URL";
  }
  if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
    return "enter a valid URL";
  }

  return null;
};

/** Ant Design Form rule: strict external website URL (http(s):// or www.). */
export const externalWebsiteUrlValidator = (rule, value, callback) => {
  try {
    if (!value || String(value).trim() === "") {
      callback();
      return;
    }
    const error = validateExternalWebsiteUrl(value);
    if (error) {
      throw new Error(error);
    }
    callback();
  } catch (err) {
    callback(err);
  }
};

/** Ant Design Form rule: optional http(s) website with plausible hostname (blocks obvious junk TLDs). */
export const websiteUrlValidator = (rule, value, callback) => {
  try {
    if (!value || String(value).trim() === "") {
      callback();
      return;
    }
    if (value !== String(value).trimStart()) {
      throw new Error("URL cannot start with whitespace");
    }
    const trimmed = String(value).trim();
    if (trimmed.length > 2048) {
      throw new Error("URL must not exceed 2048 characters");
    }
    const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed);
    const normalized = hasScheme ? trimmed : `https://${trimmed}`;
    let parsed;
    try {
      parsed = new URL(normalized);
    } catch {
      throw new Error("Please enter a valid URL");
    }
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      throw new Error("Only http:// and https:// URLs are allowed");
    }
    const host = parsed.hostname;
    if (!host || host.length > 253) {
      throw new Error("Please enter a valid URL with a domain name");
    }
    if (host.startsWith("[")) {
      callback();
      return;
    }
    if (!host.includes(".")) {
      throw new Error(
        "Please enter a full website URL"
      );
    }
    const labels = host.split(".");
    for (const label of labels) {
      if (!label || label.length > 63) {
        throw new Error("Please enter a valid domain name");
      }
      if (!/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i.test(label)) {
        throw new Error("Please enter a valid domain name");
      }
    }
    const tld = labels[labels.length - 1];
    if (!tld || tld.length < 2) {
      throw new Error("Please enter a valid domain name");
    }
    if (/(.)\1{7,}/.test(tld)) {
      throw new Error("Please enter a valid website URL");
    }
    const tldLower = tld.toLowerCase();
    const shortTldRepeats = [
      ["com", /^com+$/i],
      ["org", /^org+$/i],
      ["net", /^net+$/i],
      ["gov", /^gov+$/i],
      ["edu", /^edu+$/i],
      ["mil", /^mil+$/i],
      ["int", /^int+$/i],
      ["info", /^info+$/i],
      ["biz", /^biz+$/i],
      ["co", /^co+$/i],
      ["io", /^io+$/i],
    ];
    for (const [exact, pattern] of shortTldRepeats) {
      if (pattern.test(tld) && tldLower !== exact) {
        throw new Error("Please enter a valid website URL");
      }
    }
    callback();
  } catch (err) {
    callback(err);
  }
};

export const phoneValidator = (rule, value, callback) => {
  try {
    // If field is empty, let the required rule handle it
    if (!value || value.trim() === '') {
      callback();
      return;
    }
    
    // Check if phone starts with whitespace only
    if (value !== value.trimStart()) {
      throw new Error('Phone number cannot start with whitespace');
    }
    
    const trimmedValue = value.trim();
    
    // Check maximum length
    if (trimmedValue.length > 15) {
      throw new Error('Phone number must not exceed 15 characters');
    }
    
    // Check minimum length (at least 7 digits for a valid phone number)
    const digitsOnly = trimmedValue.replace(/[^0-9]/g, '');
    if (digitsOnly.length < 7) {
      throw new Error('Phone number must contain at least 7 digits');
    }
    
    // Check for valid characters (numbers, spaces, parentheses, periods)
    const phoneRegex = /^[0-9\s\(\)\.]+$/;
    if (!phoneRegex.test(trimmedValue)) {
      throw new Error('Phone number can only contain numbers, spaces, parentheses, and periods');
    }
    
    // Check for consecutive special characters
    if (/(\s{2,}|\(\)|\.{2,})/.test(trimmedValue)) {
      throw new Error('Phone number cannot contain consecutive special characters or empty parentheses');
    }
    
    // Check for invalid patterns like all zeros or all same digits
    if (digitsOnly.length >= 7) {
      // Check if all digits are the same (like 000000000, 111111111, etc.)
      if (/^(\d)\1+$/.test(digitsOnly)) {
        throw new Error('Phone number cannot contain all identical digits');
      }
      
      // Check if it's all zeros
      if (digitsOnly === '0'.repeat(digitsOnly.length)) {
        throw new Error('Phone number cannot be all zeros');
      }
    }
    
    callback();
  } catch (err) {
    callback(err);
  }
};

export const addressValidator = (rule, value, callback) => {
  try {
    // Address is optional, but if provided, validate format
    if (!value || value.trim() === '') {
      callback();
      return;
    }
    
    const trimmedValue = value.trim();
    
    // Check maximum length
    if (trimmedValue.length > 255) {
      throw new Error('Address must not exceed 255 characters');
    }
    
    // Check minimum length if provided
    if (trimmedValue.length < 3) {
      throw new Error('Address must be at least 3 characters long if provided');
    }
    
    // Check for valid characters (letters, numbers, spaces, common address symbols)
    const addressRegex = /^[a-zA-Z0-9\s\-#.,'\/]+$/;
    if (!addressRegex.test(trimmedValue)) {
      throw new Error('Address can only contain letters, numbers, spaces, and common address symbols (#, -, ., ,, \', /)');
    }
    
    // Check for consecutive special characters
    if (/(\s{2,}|-{2,}|\.{2,}|,{2,}|'{2,}|\/{2,})/.test(trimmedValue)) {
      throw new Error('Address cannot contain consecutive special characters');
    }
    
    // Check that address doesn't start or end with special characters
    if (/^[\s\-.,'\/]|[\s\-.,'\/]$/.test(trimmedValue)) {
      throw new Error('Address cannot start or end with spaces or special characters');
    }
    
    callback();
  } catch (err) {
    callback(err);
  }
};

export const postalCodeValidator = (rule, value, callback) => {
  try {
    // Postal code is optional, but if provided, validate format
    if (!value || value.trim() === '') {
      callback();
      return;
    }
    
    const trimmedValue = value.trim();
    
    // Check maximum length
    if (trimmedValue.length > 20) {
      throw new Error('Postal code must not exceed 20 characters');
    }
    
    // Check minimum length if provided
    if (trimmedValue.length < 3) {
      throw new Error('Postal code must be at least 3 characters long if provided');
    }
    
    // Check for valid characters (letters, numbers, spaces, hyphens)
    const postalCodeRegex = /^[a-zA-Z0-9\s\-]+$/;
    if (!postalCodeRegex.test(trimmedValue)) {
      throw new Error('Postal code can only contain letters, numbers, spaces, and hyphens');
    }
    
    // Check for consecutive special characters
    if (/(\s{2,}|-{2,})/.test(trimmedValue)) {
      throw new Error('Postal code cannot contain consecutive spaces or hyphens');
    }
    
    // Check that postal code doesn't start or end with special characters
    if (/^[\s\-]|[\s\-]$/.test(trimmedValue)) {
      throw new Error('Postal code cannot start or end with spaces or hyphens');
    }
    
    callback();
  } catch (err) {
    callback(err);
  }
};

// New phone validator for supplier and manufacturer forms (hyphen-only)
export const phoneValidatorHyphenOnly = (rule, value, callback) => {
  try {
    // If field is empty, let the required rule handle it
    if (!value || value.trim() === '') {
      callback();
      return;
    }

    const regex = /^[0-9\-]*$/;
    if (!regex.test(value)) {
      throw new Error(
        "Phone number can only contain numbers and hyphens"
      );
    }

    // Count all characters (digits and allowed symbols)
    if (value.length > 15) {
      throw new Error("Phone number must not exceed 15 characters!");
    }

    // Check for consecutive hyphens
    if (/\-{2,}/.test(value)) {
      throw new Error("Phone number cannot contain consecutive hyphens!");
    }

    // Extract only digits for validation
    const digitsOnly = value.replace(/[^0-9]/g, '');
    
    // Check for minimum length (at least 7 digits for a valid phone number)
    if (digitsOnly.length < 7) {
      throw new Error("Phone number must contain at least 7 digits!");
    }

    // Check for invalid patterns
    if (digitsOnly.length > 0) {
      // Check for all zeros (000000000, 000-000-0000, etc.)
      if (/^0+$/.test(digitsOnly)) {
        throw new Error("Phone number cannot be all zeros!");
      }

      // Check for repeated single digit (111111111, 222-222-2222, etc.)
      if (/^(\d)\1+$/.test(digitsOnly)) {
        throw new Error("Phone number cannot be all the same digit!");
      }
    }

    callback();
  } catch (err) {
    callback(err);
  }
};


export const getFileExtension = (fileName) => {
  // Extract the part of the fileName after the last dot (.)
  if (fileName) {
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex !== -1) {
      return fileName.slice(dotIndex + 1).toLowerCase();
    } else {
      return null; // No file extension found
    }
  }
  return null;
};

export const handleNumericInputChange = (
  value,
  callback,
  allowNegative = false
) => {
  if (allowNegative) {
    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
      callback();
    }
  } else {
    const reg = /^[0-9]*(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === "") {
      callback();
    }
  }
};

// Helper function to get the moment format string from localStorage
export const getMomentDateFormat = () => {
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  return format; // Already in moment format (MM/DD/YY, DD/MM/YY, YY/MM/DD)
};

// Helper function to get the moment format string for full year (YYYY instead of YY)
export const getMomentDateFormatFullYear = () => {
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  return format.replace(/YY/g, "YYYY");
};

// Helper function to get DatePicker format (for Ant Design DatePicker component)
export const getDatePickerFormat = () => {
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  return format.replace(/YY/g, "YYYY"); // DatePicker uses YYYY, not YY
};

// Helper function to get DatePicker format with time (for date-time pickers)
export const getDatePickerFormatWithTime = () => {
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  const dateFormat = format.replace(/YY/g, "YYYY");
  return `${dateFormat} HH:mm:ss A`; // Add time format
};

// Helper function to format date with time in a readable format (e.g., "Do MMM YYYY LT")
export const formatDateWithTimeReadable = (date) => {
  if (!date || date === null) return 'N/A';
  
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  
  // Map format to moment format with full date and time
  let momentFormat;
  switch (format) {
    case "MM/DD/YY":
      momentFormat = "MMM Do, YYYY LT";
      break;
    case "DD/MM/YY":
      momentFormat = "Do MMM YYYY LT";
      break;
    case "YY/MM/DD":
      momentFormat = "YYYY MMM Do LT";
      break;
    default:
      momentFormat = "MMM Do, YYYY LT";
  }
  
  // Handle UTC dates properly
  return moment.utc(date).local().format(momentFormat);
};

// Function to format date - now uses localStorage format
export const formatDate = (date) => {
  if (!date || date === null) return 'N/A'; // Check if date is null or undefined

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'N/A'; // Check if the date is invalid

  const day = ("0" + d.getDate()).slice(-2);  
  const month = ("0" + (d.getMonth() + 1)).slice(-2);  
  const year = d.getFullYear().toString().slice(-2); // Get last 2 digits of year

  // Get the format from localStorage
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  
  switch (format) {
    case "MM/DD/YY":
      return `${month}/${day}/${year}`;
    case "DD/MM/YY":
      return `${day}/${month}/${year}`;
    case "YY/MM/DD":
      return `${year}/${month}/${day}`;
    default:
      return `${month}/${day}/${year}`;
  }
};

export const formatToMMDDYYYY = (date) => {
  if (!date || date === null) return 'N/A'; // Check if date is null or undefined

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'N/A'; // Check if the date is invalid

  const day = ("0" + d.getDate()).slice(-2);  
  const month = ("0" + (d.getMonth() + 1)).slice(-2);  
  const year = d.getFullYear();

  // Get the format from localStorage
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  
  switch (format) {
    case "MM/DD/YY":
      return `${month}/${day}/${year}`;
    case "DD/MM/YY":
      return `${day}/${month}/${year}`;
    case "YY/MM/DD":
      return `${year}/${month}/${day}`;
    default:
      return `${month}/${day}/${year}`;
  }
};

// New function that uses the date format from context
export const formatDateWithContext = (date) => {
  if (!date || date === null) return 'N/A'; // Check if date is null or undefined

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'N/A'; // Check if the date is invalid

  const day = ("0" + d.getDate()).slice(-2);  
  const month = ("0" + (d.getMonth() + 1)).slice(-2);  
  const year = d.getFullYear().toString().slice(-2); // Get last 2 digits of year

  // Get the format from localStorage
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  
  switch (format) {
    case "MM/DD/YY":
      return `${month}/${day}/${year}`;
    case "DD/MM/YY":
      return `${day}/${month}/${year}`;
    case "YY/MM/DD":
      return `${year}/${month}/${day}`;
    default:
      return `${month}/${day}/${year}`;
  }
};

// New function that uses the date format from context with time
export const formatDateWithContextAndTime = (date) => {
  if (!date || date === null) return 'N/A'; // Check if date is null or undefined

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'N/A'; // Check if the date is invalid

  const day = ("0" + d.getDate()).slice(-2);  
  const month = ("0" + (d.getMonth() + 1)).slice(-2);  
  const year = d.getFullYear().toString().slice(-2); // Get last 2 digits of year

  let hours = d.getHours();
  const minutes = ("0" + d.getMinutes()).slice(-2);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  const formattedTime = `${hours}:${minutes} ${ampm}`;

  // Get the format from localStorage
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  
  let formattedDate;
  switch (format) {
    case "MM/DD/YY":
      formattedDate = `${month}/${day}/${year}`;
      break;
    case "DD/MM/YY":
      formattedDate = `${day}/${month}/${year}`;
      break;
    case "YY/MM/DD":
      formattedDate = `${year}/${month}/${day}`;
      break;
    default:
      formattedDate = `${month}/${day}/${year}`;
  }

  return `${formattedDate} ${formattedTime}`;
};

export const formatToDDMMYYYY = (dateString) => {
  if (!dateString || dateString === null) return 'N/A';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'N/A';
  
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getUTCFullYear().toString().slice(-2); // Get last 2 digits

  // Get the format from localStorage
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  
  switch (format) {
    case "MM/DD/YY":
      return `${month}/${day}/${year}`;
    case "DD/MM/YY":
      return `${day}/${month}/${year}`;
    case "YY/MM/DD":
      return `${year}/${month}/${day}`;
    default:
      return `${month}/${day}/${year}`;
  }
}

export const formatToMMDDYYYYHHMM = (date) => {
  if (!date || date === null) return 'N/A'; // Check if date is null or undefined

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'N/A'; // Check if the date is invalid

  const day = ("0" + d.getDate()).slice(-2);  
  const month = ("0" + (d.getMonth() + 1)).slice(-2);  
  const year = d.getFullYear().toString().slice(-2); // Get last 2 digits of year

  let hours = d.getHours();
  const minutes = ("0" + d.getMinutes()).slice(-2);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  const formattedTime = `${hours}:${minutes} ${ampm}`;

  // Get the format from localStorage
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  
  let formattedDate;
  switch (format) {
    case "MM/DD/YY":
      formattedDate = `${month}/${day}/${year}`;
      break;
    case "DD/MM/YY":
      formattedDate = `${day}/${month}/${year}`;
      break;
    case "YY/MM/DD":
      formattedDate = `${year}/${month}/${day}`;
      break;
    default:
      formattedDate = `${month}/${day}/${year}`;
  }

  return `${formattedDate} ${formattedTime}`;
};

// Updated function that uses context format with time
export const formatToMMDDYYYYHHMMWithContext = (date) => {
  if (!date || date === null) return 'N/A'; // Check if date is null or undefined

  const d = new Date(date);
  if (isNaN(d.getTime())) return 'N/A'; // Check if the date is invalid

  const day = ("0" + d.getDate()).slice(-2);  
  const month = ("0" + (d.getMonth() + 1)).slice(-2);  
  const year = d.getFullYear().toString().slice(-2); // Get last 2 digits of year

  let hours = d.getHours();
  const minutes = ("0" + d.getMinutes()).slice(-2);
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  const formattedTime = `${hours}:${minutes} ${ampm}`;

  // Get the format from localStorage
  const format = localStorage.getItem("dateFormat") || "MM/DD/YY";
  
  let formattedDate;
  switch (format) {
    case "MM/DD/YY":
      formattedDate = `${month}/${day}/${year}`;
      break;
    case "DD/MM/YY":
      formattedDate = `${day}/${month}/${year}`;
      break;
    case "YY/MM/DD":
      formattedDate = `${year}/${month}/${day}`;
      break;
    default:
      formattedDate = `${month}/${day}/${year}`;
  }

  return `${formattedDate} ${formattedTime}`;
};

// Currency helpers (similar to date format helpers)
let activeCurrencySymbolMap = {};
let activeCurrencyByIdMap = {};

let activeCurrencyByCodeMap = {};

export const setActiveCurrencyMap = (list) => {
  activeCurrencySymbolMap = {};
  activeCurrencyByIdMap = {};
  activeCurrencyByCodeMap = {};
  (list || []).forEach((item) => {
    if (!item) return;
    const code = item.currencyCode ? String(item.currencyCode).toUpperCase() : "";
    if (code) {
      activeCurrencySymbolMap[code] = item.currencySymbol || item.currencyCode;
    }
    if (item.id != null && item.id !== "") {
      const id = Number(item.id);
      activeCurrencyByIdMap[id] = {
        code: item.currencyCode || "",
        symbol: item.currencySymbol || item.currencyCode || "",
      };
      if (code) {
        activeCurrencyByCodeMap[code] = id;
      }
    }
  });
};

/** Resolve currency code/symbol from active list by id (for view when BE sends only currencyId). */
export const getCurrencyById = (currencyId) => {
  if (currencyId == null || currencyId === "") {
    return null;
  }
  return activeCurrencyByIdMap[Number(currencyId)] || null;
};

export const getSelectedCurrencyCode = () => {
  try {
    return localStorage.getItem("defaultCurrency") || "USD";
  } catch (e) {
    return "USD";
  }
};

export const getSelectedCurrencyId = () => {
  try {
    const stored = localStorage.getItem("defaultCurrencyId");
    const num = stored != null && stored !== "" ? Number(stored) : NaN;
    return !Number.isNaN(num) && num > 0 ? num : null;
  } catch (e) {
    return null;
  }
};

export const getCurrencyIdByCode = (currencyCode) => {
  if (currencyCode) {
    const id = activeCurrencyByCodeMap[String(currencyCode).toUpperCase()];
    if (id != null) return id;
  }
  return getSelectedCurrencyId();
};

export const getCurrencyLocale = (currencyCode) => {
  const code = (currencyCode || getSelectedCurrencyCode() || "USD").toUpperCase();
  // const currencyToLocale = {
  //   USD: "en-US",
  //   EUR: "en-IE", // neutral English for EUR
  //   GBP: "en-GB",
  //   INR: "en-IN",
  //   AUD: "en-AU",
  //   CAD: "en-CA",
  //   JPY: "ja-JP",
  //   CNY: "zh-CN",
  //   SGD: "en-SG",
  //   NZD: "en-NZ",
  // };
  const currencyToLocale = {
    // 🌎 North America
    USD: "en-US", // US Dollar
    CAD: "en-CA", // Canadian Dollar
    MXN: "es-MX", // Mexican Peso
    BZD: "en-BZ", // Belize Dollar
    BSD: "en-BS", // Bahamian Dollar
    BBD: "en-BB", // Barbadian Dollar
    JMD: "en-JM", // Jamaican Dollar
    TTD: "en-TT", // Trinidad & Tobago Dollar
    DOP: "es-DO", // Dominican Peso

    // 🇪🇺 Europe
    EUR: "en-IE", // Euro
    GBP: "en-GB", // British Pound
    CHF: "de-CH", // Swiss Franc
    SEK: "sv-SE", // Swedish Krona
    NOK: "nb-NO", // Norwegian Krone
    DKK: "da-DK", // Danish Krone
    PLN: "pl-PL", // Polish Zloty
    CZK: "cs-CZ", // Czech Koruna
    HUF: "hu-HU", // Hungarian Forint
    RON: "ro-RO", // Romanian Leu
    BGN: "bg-BG", // Bulgarian Lev
    HRK: "hr-HR", // Croatian Kuna
    ISK: "is-IS", // Icelandic Krona
    RUB: "ru-RU", // Russian Ruble
    UAH: "uk-UA", // Ukrainian Hryvnia
    RSD: "sr-RS", // Serbian Dinar
    ALL: "sq-AL", // Albanian Lek
    MDL: "ro-MD", // Moldovan Leu

    // 🇮🇳 Asia
    INR: "en-IN", // Indian Rupee
    PKR: "ur-PK", // Pakistani Rupee
    BDT: "bn-BD", // Bangladeshi Taka
    NPR: "ne-NP", // Nepalese Rupee
    LKR: "si-LK", // Sri Lankan Rupee
    MVR: "dv-MV", // Maldivian Rufiyaa
    MMK: "my-MM", // Myanmar Kyat
    THB: "th-TH", // Thai Baht
    MYR: "ms-MY", // Malaysian Ringgit
    IDR: "id-ID", // Indonesian Rupiah
    PHP: "en-PH", // Philippine Peso
    VND: "vi-VN", // Vietnamese Dong
    CNY: "zh-CN", // Chinese Yuan
    HKD: "zh-HK", // Hong Kong Dollar
    TWD: "zh-TW", // Taiwan Dollar
    KRW: "ko-KR", // South Korean Won
    JPY: "ja-JP", // Japanese Yen
    KZT: "kk-KZ", // Kazakhstani Tenge
    UZS: "uz-UZ", // Uzbekistani Som
    MNT: "mn-MN", // Mongolian Tögrög
    LAK: "lo-LA", // Lao Kip

    // 🇦🇺 Oceania
    AUD: "en-AU", // Australian Dollar
    NZD: "en-NZ", // New Zealand Dollar
    FJD: "en-FJ", // Fijian Dollar
    PGK: "en-PG", // Papua New Guinean Kina
    WST: "en-WS", // Samoan Tala
    TOP: "en-TO", // Tongan Paʻanga
    SBD: "en-SB", // Solomon Islands Dollar
    VUV: "en-VU", // Vanuatu Vatu

    // 🇲🇪 Middle East
    AED: "ar-AE", // UAE Dirham
    SAR: "ar-SA", // Saudi Riyal
    QAR: "ar-QA", // Qatari Riyal
    KWD: "ar-KW", // Kuwaiti Dinar
    BHD: "ar-BH", // Bahraini Dinar
    OMR: "ar-OM", // Omani Rial
    JOD: "ar-JO", // Jordanian Dinar
    LBP: "ar-LB", // Lebanese Pound
    ILS: "he-IL", // Israeli Shekel
    TRY: "tr-TR", // Turkish Lira
    IRR: "fa-IR", // Iranian Rial
    YER: "ar-YE", // Yemeni Rial

    // 🇿🇦 Africa
    ZAR: "en-ZA", // South African Rand
    EGP: "ar-EG", // Egyptian Pound
    NGN: "en-NG", // Nigerian Naira
    KES: "en-KE", // Kenyan Shilling
    GHS: "en-GH", // Ghanaian Cedi
    TZS: "sw-TZ", // Tanzanian Shilling
    UGX: "en-UG", // Ugandan Shilling
    MAD: "fr-MA", // Moroccan Dirham
    DZD: "ar-DZ", // Algerian Dinar
    TND: "ar-TN", // Tunisian Dinar
    SDG: "ar-SD", // Sudanese Pound
    ETB: "am-ET", // Ethiopian Birr
    XAF: "fr-CM", // Central African Franc (CEMAC)
    XOF: "fr-SN", // West African Franc (UEMOA)
    MWK: "en-MW", // Malawian Kwacha
    ZMW: "en-ZM", // Zambian Kwacha
    BWP: "en-BW", // Botswana Pula

    // 🇧🇷 South America
    BRL: "pt-BR", // Brazilian Real
    ARS: "es-AR", // Argentine Peso
    CLP: "es-CL", // Chilean Peso
    COP: "es-CO", // Colombian Peso
    PEN: "es-PE", // Peruvian Sol
    UYU: "es-UY", // Uruguayan Peso
    PYG: "es-PY", // Paraguayan Guarani
    BOB: "es-BO", // Bolivian Boliviano
    VES: "es-VE", // Venezuelan Bolívar

    // Others / Territories
    XPF: "fr-PF", // CFP Franc (French Polynesia, New Caledonia)
    MUR: "en-MU", // Mauritian Rupee
    SCR: "en-SC", // Seychellois Rupee
    LRD: "en-LR", // Liberian Dollar
    SLL: "en-SL", // Sierra Leonean Leone
  };
  return currencyToLocale[code] || "en-US";
};

export const formatCurrency = (amount, options = {}) => {
  const currencyCode = (options.currencyCode || getSelectedCurrencyCode() || "USD").toUpperCase();
  const locale = options.locale || getCurrencyLocale(currencyCode);
  const number = typeof amount === "number" ? amount : parseFloat(amount || 0);
  let safeNumber = Number.isFinite(number) ? number : 0;
  
  // Get the custom currency symbol from localStorage
  const customSymbol = localStorage.getItem("defaultCurrencySymbol");
  
  try {
    if (customSymbol && !options.currencyCode) {
      // Use custom symbol with number formatting (no currency style)
      const formatter = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return `${customSymbol}${formatter.format(safeNumber)}`;
    } else {
      // Use standard currency formatting for specific currency codes
      const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode,
      });
      return formatter.format(safeNumber);
    }
  } catch (e) {
    // Fallback simple formatting
    const symbol = customSymbol || currencyCode;
    return `${symbol} ${safeNumber.toFixed(2)}`;
  }
};

export const getCurrencySymbol = (currencyCode) => {
  // First, try to get the stored custom symbol from localStorage
  const storedSymbol = localStorage.getItem("defaultCurrencySymbol");
  if (storedSymbol && !currencyCode) {
    // If no specific currency code is requested, return the stored symbol
    return storedSymbol;
  }
  
  // If a specific currency code is requested, try to derive its symbol
  if (currencyCode) {
    const code = currencyCode.toUpperCase();
    if (activeCurrencySymbolMap[code]) {
      return activeCurrencySymbolMap[code];
    }
    const locale = getCurrencyLocale(code);
    try {
      const parts = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: code,
        currencyDisplay: "symbol",
      }).formatToParts(0);
      const symbolPart = parts.find((p) => p.type === "currency");
      return symbolPart ? symbolPart.value : code;
    } catch (e) {
      return code;
    }
  }
  
  // Fallback to stored symbol or default
  return storedSymbol || "$";
};

export const resolveCurrencyDisplay = (currency) => {
  const fromId =
    currency && currency.currencyId != null && currency.currencyId !== ""
      ? getCurrencyById(currency.currencyId)
      : null;
  const currencyCode =
    (currency && (currency.currencyCode || currency.code)) ||
    (fromId && fromId.code) ||
    getSelectedCurrencyCode();
  const currencySymbol =
    (currency && (currency.currencySymbol || currency.symbol)) ||
    (fromId && fromId.symbol) ||
    getCurrencySymbol(currencyCode);
  return {
    currencyId:
      currency && currency.currencyId != null && currency.currencyId !== ""
        ? Number(currency.currencyId)
        : null,
    currencyCode,
    currencySymbol,
  };
};

export const formatAmountWithCurrency = (amount, currency) => {
  if (amount == null || amount === "") return "-";
  const { currencySymbol } = resolveCurrencyDisplay(currency);
  return `${currencySymbol}${amount}`;
};
